import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from '../notifier';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import api from '../../api/backend'

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    submit: {
        marginTop: 20
    },
    table: {
        marginTop: 50
    }
});

class AddCourse extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { courses: [], myCourses: [], paymentStatus: '', type: '', courseId: '' }
    }

    addCourse = (event) => {
        event.preventDefault();
        const { paymentStatus, courseId, type } = this.state
        const { user } = this.props
        api.createMyCourse(courseId, { paymentStatus, user: user.userName, type }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                openSnackbar({ message: 'เพิ่มคอร์สสำเร็จ' })
                this.setState({ paymentStatus: '', courseId: '', type: '' })
                this.getMyCourse()
            } else {
                console.error('ไม่สามารถเพิ่มคอร์สได้')
                openSnackbar({ message: 'ไม่สามารถเพิ่มคอร์สได้' })
                this.setState({ loading: false });
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
            this.setState({ loading: false });
        })
    }

    deleteCourse = (id) => {
        api.deleteMyCourse(id).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.getMyCourse()
            } else {
                console.error(`ไม่สามารถลบคอร์สได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    closeAndClear = () => {
        this.setState({ show: false })
    }

    getMyCourse = () => {
        const { user } = this.props
        api.getMyCourse(user.userName).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ myCourses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    getCourse = () => {
        api.getCourses().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ courses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }
    componentDidMount() {
        // this.getCourse()
        // this.getMyCourse()
    }
    render() {
        const { classes } = this.props
        const { paymentStatus, courseId, courses, myCourses, loading } = this.state
        return (
            <React.Fragment>
                <TableCell numeric onClick={() => {
                    this.getCourse()
                    this.getMyCourse()
                    this.setState({ show: true })
                }} style={{ cursor: 'pointer' }}>Course</TableCell>

                <Dialog
                    open={this.state.show}
                    onClose={this.closeAndClear}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="form-dialog-title">แก้ไขผู้ใช้งาน</DialogTitle>
                    <DialogContent>
                        <Notifier />
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel htmlFor="courseId-helper">คอร์ส</InputLabel>
                                    <Select
                                        value={courseId}
                                        onChange={(event) => { this.setState({ courseId: event.target.value }) }}
                                        input={<Input name="courseId" id="courseId-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {courses.filter(e => {
                                            let x = true
                                            myCourses.forEach(element => {
                                                if (element.course.id === e.course.id) x = false
                                            })
                                            return x
                                        }).map(course => <MenuItem key={course.course.id} value={course.course.id}>{course.course.title}</MenuItem>)}
                                    </Select>
                                    <FormHelperText>เลือกคอร์ส</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel htmlFor="paymentStatus-helper">เลือกสถานะการชำระเงิน</InputLabel>
                                    <Select
                                        value={paymentStatus}
                                        onChange={(event) => { this.setState({ paymentStatus: event.target.value }) }}
                                        input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Inprogress">รอชำระ</MenuItem>
                                        <MenuItem value="Completed">ชำระแล้ว</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกสถานะการชำระเงิน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel htmlFor="paymentStatus-helper">ประเภท</InputLabel>
                                    <Select
                                        value={this.state.type}
                                        onChange={(event) => { this.setState({ type: event.target.value }) }}
                                        input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="เรียนออนไลน์">เรียนออนไลน์</MenuItem>
                                        <MenuItem value="เรียนออนไลน์+เรียนสด">เรียนออนไลน์+เรียนสด</MenuItem>
                                    </Select>
                                    <FormHelperText>ประเภทการเรียน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <div className={classes.wrapper}>
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    disabled={loading}
                                    className={classes.submit}
                                    size="large"
                                    fullWidth
                                    onClick={this.addCourse}
                                >
                                    เพิ่มคอร์ส
                                    </Button>
                                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </Grid>
                        <div className={classes.table}>
                            <Typography variant="title" gutterBottom>
                                คอร์สที่ลงเรียนแล้ว
                            </Typography>
                            <Table padding='none'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>คอร์ส</TableCell>
                                        <TableCell numeric>ประเภท</TableCell>
                                        <TableCell numeric>สถานะ</TableCell>
                                        <TableCell numeric style={{ width: 50 }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {myCourses.map(course => <TableRow key={course.id} >
                                        <TableCell component="th" scope="row">
                                            {course.course.title}
                                        </TableCell>
                                        <TableCell numeric>{course.type}</TableCell>
                                        <TableCell numeric>{course.paymentStatus === 'Inprogress' ? 'รอชำระ' : 'ชำระแล้ว'}</TableCell>
                                        <TableCell numeric>
                                            <IconButton aria-label="Delete" onClick={() => this.deleteCourse(course.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table>
                        </div>
                    </DialogContent>
                    {/* <DialogActions>
                        <Button onClick={this.closeAndClear} color="default" disabled={loading}>
                            ยกเลิก
                        </Button>
                        <Button onClick={this.addCourse} color="primary" disabled={loading}>
                            เพิ่มคอร์ส
                        </Button>
                        {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : <React.Fragment>
                        </React.Fragment>}
                    </DialogActions> */}
                </Dialog>

                {/* <Drawer anchor="right" open={this.state.show} classes={{
                    paper: classes.drawer,
                }} onClose={this.closeAndClear}>

                    <Notifier />
                    <Card className={classes.card}>
                        <CardHeader
                            title={<Typography variant="title" gutterBottom>
                                จัดการคอร์สสำหรับผู้เรียน
                            </Typography>} />
                        <CardContent className={classes.cardContent}>
                            <form className={classes.form} onSubmit={this.addCourse}>
                                <Grid container spacing={24}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} fullWidth required>
                                            <InputLabel htmlFor="courseId-helper">คอร์ส</InputLabel>
                                            <Select
                                                value={courseId}
                                                onChange={(event) => { this.setState({ courseId: event.target.value }) }}
                                                input={<Input name="courseId" id="courseId-helper" required />}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {courses.filter(e => {
                                                    let x = true
                                                    myCourses.forEach(element => {
                                                        if (element.course.id === e.course.id) x = false
                                                    })
                                                    return x
                                                }).map(course => <MenuItem key={course.course.id} value={course.course.id}>{course.course.title}</MenuItem>)}
                                            </Select>
                                            <FormHelperText>เลือกคอร์ส</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} fullWidth required>
                                            <InputLabel htmlFor="paymentStatus-helper">เลือกสถานะการชำระเงิน</InputLabel>
                                            <Select
                                                value={paymentStatus}
                                                onChange={(event) => { this.setState({ paymentStatus: event.target.value }) }}
                                                input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="Inprogress">รอชำระ</MenuItem>
                                                <MenuItem value="Completed">ชำระแล้ว</MenuItem>
                                            </Select>
                                            <FormHelperText>เลือกสถานะการชำระเงิน</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} fullWidth required>
                                            <InputLabel htmlFor="paymentStatus-helper">ประเภท</InputLabel>
                                            <Select
                                                value={this.state.type}
                                                onChange={(event) => { this.setState({ type: event.target.value }) }}
                                                input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="เรียนออนไลน์">เรียนออนไลน์</MenuItem>
                                                <MenuItem value="เรียนออนไลน์+เรียนสด">เรียนออนไลน์+เรียนสด</MenuItem>
                                            </Select>
                                            <FormHelperText>ประเภทการเรียน</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <div className={classes.wrapper}>
                                        <Button
                                            type="submit"
                                            variant="raised"
                                            color="primary"
                                            disabled={loading}
                                            className={classes.submit}
                                            size="large"
                                            fullWidth
                                        >
                                            เพิ่มคอร์ส
                                    </Button>
                                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                    </div>
                                </Grid>
                            </form>
                            <div className={classes.table}>
                                <Typography variant="title" gutterBottom>
                                    คอร์สที่ลงเรียนแล้ว
                            </Typography>
                                <Table >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>คอร์ส</TableCell>
                                            <TableCell numeric>สถานะ</TableCell>
                                            <TableCell numeric></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {myCourses.map(course => <TableRow key={course.id} >
                                            <TableCell component="th" scope="row">
                                                {course.course.title}
                                            </TableCell>
                                            <TableCell numeric>{course.paymentStatus === 'Inprogress' ? 'รอชำระ' : 'ชำระแล้ว'}</TableCell>
                                            <TableCell numeric>
                                                <IconButton aria-label="Delete" onClick={() => this.deleteCourse(course.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </div>
                        </CardContent>
                    </Card>
                </Drawer> */}
            </React.Fragment >
        );
    }
}

export default withStyles(styles)(AddCourse);